(function(){
  function killBlockingPopups(){
    document.querySelectorAll('[id*="roundway_email_popup"], [id*="roundway_email_popup"] *, .rw-popup, .rw-popup *, .rw-popup__backdrop, .rw-popup__left, #rw-step-email').forEach(function(el){
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
    });
  }
  function unlockScroll(){
    ['html','body'].forEach(function(sel){
      var el = document.querySelector(sel);
      if(!el) return;
      el.style.setProperty('overflow','auto','important');
      el.style.setProperty('overflow-x','hidden','important');
      el.style.setProperty('height','auto','important');
      el.style.setProperty('position','static','important');
      el.style.setProperty('touch-action','auto','important');
      el.classList.remove('no-scroll','modal-open','overflow-hidden','popup-open');
    });
  }
  killBlockingPopups(); unlockScroll();
  window.addEventListener('load', function(){ killBlockingPopups(); unlockScroll(); });
  setTimeout(function(){ killBlockingPopups(); unlockScroll(); }, 600);
  setTimeout(function(){ killBlockingPopups(); unlockScroll(); }, 1600);
  setTimeout(function(){ killBlockingPopups(); unlockScroll(); }, 3000);

  // Shopify handles customer forms natively. JS only adds analytics + safe UI state.
  document.querySelectorAll('.rw-cb form.wl').forEach(function(form){
    form.addEventListener('submit', function(){
      form.classList.add('is-submitting');
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({event:'waitlist_signup', list:'core-biotic'}); } catch(_){}
    });
  });

  if (window.location.search.indexOf('customer_posted=true') !== -1) {
    document.querySelectorAll('.rw-cb form.wl').forEach(function(form){ form.classList.add('is-ok'); });
  }

  // Sticky CTA reveal after scrolling past hero.
  var hero = document.querySelector('.rw-cb .hero');
  if(!hero) return;
  var sticky = document.createElement('div');
  sticky.className = 'rw-cb-sticky';
  sticky.innerHTML = 'Core Biotic · Coming Soon <a href="#join">Join the waitlist →</a>';
  document.body.appendChild(sticky);
  var threshold = hero.getBoundingClientRect().bottom + window.scrollY;
  window.addEventListener('scroll', function(){
    if(window.scrollY > threshold) sticky.classList.add('is-visible');
    else sticky.classList.remove('is-visible');
  }, { passive:true });
})();
